// Single client-side error bus. Schema-validation failures, RPC
// rejections, and reconnect-storm warnings funnel through here so
// screens can surface a unified diagnostic strip without each one
// re-implementing toast plumbing.

export interface ProtocolErrorEvent {
  source: 'envelope' | 'rpc' | 'transport' | 'auth';
  code: string;
  detail: string;
  envelope?: unknown;
}

type Listener = (e: ProtocolErrorEvent) => void;

export class ErrorBus {
  private listeners = new Set<Listener>();

  subscribe(listener: Listener): () => void {
    this.listeners.add(listener);
    return () => this.listeners.delete(listener);
  }

  emit(e: ProtocolErrorEvent): void {
    for (const l of this.listeners) {
      try {
        l(e);
      } catch {
        // listener errors are not allowed to break the bus
      }
    }
  }
}
